// import saga helpers
import { takeLatest, call, put, all } from "redux-saga/effects";

import { PROFIT_AND_LOSS_STATEMENT_DATA_FROM_DATE_RANGE_SENT } from "./actionType";

import {
  profitAndLossStatementDataFromDateRangeSuccess,
  profitAndLossStatementDataFromDateRangeError,
} from "./action";

import { getProfitAndLossStatementDataFromDateRange } from "../../helpers/fakebackend_helper";

// worker saga: makes the api call when watcher saga sees the action

function* fetchProfitAndLossStatementDataFromDateRange(action) {
  try {
    const data = yield call(
      getProfitAndLossStatementDataFromDateRange,
      action.payload
    );
    yield put(profitAndLossStatementDataFromDateRangeSuccess(data));
  } catch (error) {
    yield put(profitAndLossStatementDataFromDateRangeError(error));
  }
}

// watcher saga: watches for actions dispatched to the store, starts worker saga

function* profitAndLossStatementDataFromDateRangeSaga() {
  yield takeLatest(
    PROFIT_AND_LOSS_STATEMENT_DATA_FROM_DATE_RANGE_SENT,
    fetchProfitAndLossStatementDataFromDateRange
  );
}

// single entry point to start all Sagas at once

export default function* ProfitAndLoss() {
  yield all([profitAndLossStatementDataFromDateRangeSaga()]);
}
